import { createSlice } from '@reduxjs/toolkit';

export interface IMessageState {
  unreadCount: number
}

const initialState: IMessageState = {
  unreadCount: 0
};
export const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload
    },
    subtractCount: (state, action) => {
      const res = state.unreadCount - action.payload
      state.unreadCount = Math.max(res, 0)
    }
  }
});

export const { setUnreadCount, subtractCount } = messageSlice.actions;
export default messageSlice.reducer;
